import { fetchStateCode } from './shared';

const { Engine } = require('json-rules-engine')


const rules = {
    "conditions": {
        "all": [
            {
                "fact": "Browser pre-fill count",
                "operator": "lessThan",
                "value": 1
            },
            {
                "any": [
                    {
                        "fact": "State code match",
                        "operator": "equal",
                        "value": "no"
                    },
                    {
                        "fact": "Email and (first & last) name correlation",
                        "operator": "lessThanInclusive",
                        "value": 2
                    }
                ]
            }
        ]
    },
    "event": {
        "type": "Show Resistance",
        "params": {
            "": ""
        }
    }
}

// ruleEngineFacts

/**
 * 
 * @param {firstName: String, lastName: String, email: String, phone: String, state: String, browserPrefillCount: number} facts 
 */
function ruleEngine(facts){

    let engine = new Engine();


    engine.addRule(rules);

    return engine
    .run(facts)
    .then(({ events }) => {
        return events;
    })
}


export default ruleEngine;